<template>
  <span>Page Not Found</span>
</template>

<script>
export default {
  created () {
    this.$store.commit('hideNavigation')
  }
}
</script>
